import React from 'react';
import Products from "./Products";
import Login from "./buttons/Login";


const Home = () => {
    return (




        <div className="">

            <div class="cardd bg-white text-white">
                <div class="row g-0">
                    <div class="gambar col-sm">
                        <img src="/assets/bg.png" class="img-fluid rounded-start" alt="..."></img>
                    </div>
                    <div class="title--card col-sm ">
                        <div class="card-bodyy">
                            <h1 class="card-title fw-bolder">LET'S GO SHOPPING</h1>
                            <h4 class="card-text text-dark">CHECK OUT ALL TRENDS</h4>

                        </div>
                    </div>

                </div>
                <Products />
            </div>
        </div>


    );
};

export default Home;
